import React, { useEffect, useState } from "react";

import { Modal, Select } from "antd";
import { ErrorMessage, Field, Form, Formik } from "formik";

import { CompanyParams } from "../../../Context/companyContext";
import api from "../../../services/api";
import designSystemColors from "../../../styles";
import { notifyError, notifySucces } from "../../../utils/notifications";
import * as S from "../../creditCard/style";
import InputCard from "../../InputCard";
import editDependentSchema from "./schema";
import { ContainerSelect, ModalRowWrap } from "./styles";
import DSButton from "../../DSButton";

const { Option } = Select;

export const ModalEditDependant = ({
  open,
  closeModal,
  dependent,
  grauParentesco,
  setUpdateDepedents,
  client,
}) => {
  const [dependente, setDependente] = useState({
    cpf: "",
    dataNascimento: "",
    grauParentesco: "",
    nome: "",
    nomeMae: "",
    nomeSocial: "",
    sexo: "",
  });

  const [contato, setContato] = useState({
    faturaDigital: "",
    receberSMS: "",
    tipo: "",
    ramal: "",
    area: "",
    telefone: "",
  });

  const [loading, setLoading] = useState(false);
  const { companyParams } = CompanyParams();

  useEffect(() => {
    if (dependent) {
      setDependente({
        cpf: dependent.cpf || "",
        dataNascimento:
          dependent.dataNascimento.split("-").reverse().join("-") || "",
        grauParentesco: grauParentesco[dependent.idGrauParentesco] || "",
        nome: dependent.nome || "",
        nomeSocial: dependent.nomeSocial || "",
        nomeMae: dependent.nomeMae || "",
        sexo:
          dependent.sexo === "M" || dependent?.sexo === "MASCULINO"
            ? "MASCULINO"
            : "FEMININO" || "",
      });

      setContato({
        faturaDigital: "",
        receberSMS: "",
        tipo: "",
        ramal: "",
        area: dependent.areaTelefone || "",
        telefone: dependent.numeroTelefone || "",
      });
    }
  }, [dependent, grauParentesco]);

  const handleChangeTitular = (event) => {
    const { id, value } = event.target;
    setDependente((prev) => ({ ...prev, [id]: value }));
  };

  const handleChangeContato = (event) => {
    const { id, value } = event.target;
    setContato((prev) => ({ ...prev, [id]: value }));
  };

  const handleChangeSelectTitular = (value, field, setFieldValue) => {
    setFieldValue(field, value);
    setDependente((prev) => ({ ...prev, [field]: value }));
  };

  const editDependent = async (currentValue, initialValue) => {
    try {
      setLoading(true);

      const hasChanged = {
        nome: currentValue?.nome !== initialValue?.nome,
        nomeSocial: currentValue?.nomeSocial !== initialValue?.nomeSocial,
        dataNascimento:
          currentValue?.dataNascimento !== initialValue?.dataNascimento,
        grauParentesco:
          currentValue?.grauParentesco !== initialValue?.grauParentesco,
        nomeMae: currentValue?.nomeMae !== initialValue?.nomeMae,
        sexo: currentValue?.sexo !== initialValue?.sexo,
        area: currentValue?.area !== initialValue?.area,
        telefone: currentValue?.telefone !== initialValue?.telefone,
      };

      const hasAnyChange = Object.values(hasChanged).some(
        (changed) => changed === true
      );

      if (!hasAnyChange) {
        notifyError("Nenhuma alteração detectada.");
        return;
      }

      const formatedDate = currentValue.dataNascimento.replace(/\//g, "-");

      const data = {
        cpf: `${currentValue.cpf.split(".").join("").replace("-", "")}`,
        dataNascimento: formatedDate.split("-").reverse().join("-"),
        grauParentesco: `${currentValue.grauParentesco}`,
        nome: currentValue?.nome,
        nomeSocial:
          currentValue?.nomeSocial === ""
            ? undefined
            : currentValue?.nomeSocial,
        nomeMae: currentValue.nomeMae,
        sexo:
          currentValue?.sexo === "M" || currentValue?.sexo === "MASCULINO"
            ? "MASCULINO"
            : "FEMININO",
        telefone: {
          faturaDigital: "false",
          receberSMS: "false",
          area: `${currentValue.area}`,
          telefone: `${currentValue.telefone.replace("_", "")}`,
          tipo: "CELULAR",
        },
        hasChanged,
      };

      await api.patch("client_dependent", {
        dependent_id: dependent.id,
        client_id: client.client.id,
        ...data,
      });

      closeModal();
      notifySucces("Dependente editado com sucesso");
    } catch (error) {
      const stringError = error.message;
      notifyError("Erro ao editar dependente");
    } finally {
      setLoading(false);
      setUpdateDepedents();
    }
  };

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const digits = value.replace(/\D/g, "");
    if (digits.length >= 9) {
      return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
    }
    return digits;
  };

  const hasFormChanged = (currentValues, initialValues) => {
    const keysToCompare = [
      "nome",
      "nomeSocial",
      "dataNascimento",
      "grauParentesco",
      "nomeMae",
      "sexo",
      "area",
      "telefone",
    ];

    return keysToCompare.some(
      (key) => currentValues[key] !== initialValues[key]
    );
  };

  const initialFormValues = {
    nome: dependent?.nome || "",
    nomeSocial: dependent?.nomeSocial || "",
    dataNascimento:
      dependent?.dataNascimento.split("-").reverse().join("-") || "",
    cpf: dependent?.cpf || "",
    sexo:
      dependent?.sexo || dependent?.sexo === "MASCULINO"
        ? "MASCULINO"
        : "FEMININO" || "",
    grauParentesco: grauParentesco[dependent?.idGrauParentesco] || "",
    nomeMae: dependent?.nomeMae || "",
    area: dependent?.areaTelefone || "",
    telefone: formatPhoneNumber(dependent?.numeroTelefone || ""),
  };

  return (
    <Modal
      title="Editar Dependente"
      visible={open}
      onCancel={closeModal}
      closable={!loading}
      maskClosable={!loading}
      keyboard={!loading}
    >
      <h1>Informações Dependente</h1>
      <Formik
        enableReinitialize
        initialValues={initialFormValues}
        validationSchema={editDependentSchema}
        onSubmit={(values, { setSubmitting, resetForm }) =>
          editDependent(values, initialFormValues, resetForm)
        }
      >
        {({ setFieldValue, values, isValid }) => {
          const isFormModified = hasFormChanged(values, initialFormValues);
          const isButtonDisabled = !isValid || loading || !isFormModified;

          return (
            <Form>
              <S.ModalAddWrapper>
                <S.ModalRowWrap>
                  <Field name="nome">
                    {({ field, meta }) => (
                      <InputCard
                        addonBefore="Nome"
                        placeholder="Nome"
                        maskChar=""
                        maxLength={79}
                        className={
                          meta.touched && meta.error ? "error-id" : null
                        }
                        requiredInfo
                        {...field}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    name="nome"
                    component="div"
                    className="error-message"
                  />
                </S.ModalRowWrap>

                <S.ModalRowWrap>
                  <Field name="nomeSocial">
                    {({ field, meta }) => (
                      <InputCard
                        addonBefore="Nome Social"
                        placeholder="Nome Social"
                        maskChar=""
                        maxLength={79}
                        className={
                          meta.touched && meta.error ? "error-id" : null
                        }
                        {...field}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    name="nomeSocial"
                    component="div"
                    className="error-message"
                  />
                </S.ModalRowWrap>
                <S.ModalRowWrap>
                  <S.inputW50>
                    <Field name="dataNascimento">
                      {({ field, meta }) => (
                        <InputCard
                          value={dependente.dataNascimento}
                          addonBefore="Nascimento"
                          placeholder="dd/mm/yyyy"
                          mask="99/99/9999"
                          maskChar=""
                          onChange={handleChangeTitular}
                          className={
                            meta.touched && meta.error ? "error-id" : null
                          }
                          requiredInfo
                          {...field}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="dataNascimento"
                      component="div"
                      className="error-message"
                    />
                  </S.inputW50>
                  <S.inputW50>
                    <Field name="cpf">
                      {({ field, meta }) => (
                        <InputCard
                          value={dependente.cpf}
                          addonBefore="CPF"
                          mask="999.999.999-99"
                          maskChar=""
                          placeholder="999.999.999-99"
                          maxLength={80}
                          onChange={handleChangeTitular}
                          className={
                            meta.touched && meta.error ? "error-id" : null
                          }
                          disabled
                          style={{
                            cursor: "not-allowed",
                            backgroundColor: "#f5f5f5",
                            color: "#000",
                          }}
                          requiredInfo
                          {...field}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="cpf"
                      component="div"
                      className="error-message"
                    />
                  </S.inputW50>
                </S.ModalRowWrap>
                <ModalRowWrap>
                  <ContainerSelect>
                    <p className="title">
                      <span
                        style={{
                          color: "#ff4d4f",
                        }}
                      >
                        *{" "}
                      </span>
                      Sexo
                    </p>
                    <Field name="sexo">
                      {({ field, meta }) => (
                        <Select
                          defaultValue={values.sexo}
                          value={values.sexo}
                          maskChar={null}
                          {...field}
                          id="sexo"
                          className={
                            meta.touched && meta.error ? "error-id" : null
                          }
                          onChange={(value) => {
                            handleChangeSelectTitular(
                              value,
                              "sexo",
                              setFieldValue
                            );
                          }}
                        >
                          <Option value="">Sexo</Option>
                          <Option value="MASCULINO">Masculino</Option>
                          <Option value="FEMININO">Feminino</Option>
                        </Select>
                      )}
                    </Field>
                    <ErrorMessage
                      name="sexo"
                      component="div"
                      className="error-message"
                    />
                  </ContainerSelect>
                  <ContainerSelect>
                    <p className="title">
                      <span
                        style={{
                          color: "#ff4d4f",
                        }}
                      >
                        *{" "}
                      </span>
                      Grau Parentesco
                    </p>
                    <Field name="grauParentesco">
                      {({ field, meta }) => (
                        <Select
                          value={values.grauParentesco}
                          maskChar={null}
                          {...field}
                          id="grauParentesco"
                          onChange={(value) => {
                            handleChangeSelectTitular(
                              value,
                              "grauParentesco",
                              setFieldValue
                            );
                          }}
                          className={
                            meta.touched && meta.error ? "error-id" : null
                          }
                        >
                          <Option value="">Grau de parentesco</Option>
                          <Option value="PAI">Pai</Option>
                          <Option value="MAE">Mãe</Option>
                          <Option value="FILHO">Filho</Option>
                          <Option value="IRMAO">Irmão</Option>
                          <Option value="CONJUGE">Conjuge</Option>
                          {!companyParams?.name
                            ?.toLowerCase()
                            ?.includes("lopes") && (
                            <Option value="OUTROS">Outros</Option>
                          )}
                        </Select>
                      )}
                    </Field>
                    <ErrorMessage
                      name="grauParentesco"
                      component="div"
                      className="error-message"
                    />
                  </ContainerSelect>
                </ModalRowWrap>
                <S.ModalRowWrap>
                  <Field name="nomeMae">
                    {({ field, meta }) => (
                      <InputCard
                        value={dependente.nomeMae}
                        addonBefore="Nome da Mãe"
                        placeholder="Nome da mãe"
                        maxLength={79}
                        onChange={handleChangeTitular}
                        className={
                          meta.touched && meta.error ? "error-id" : null
                        }
                        requiredInfo
                        {...field}
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    name="nomeMae"
                    component="div"
                    className="error-message"
                  />
                </S.ModalRowWrap>
                <S.ModalRowWrap>
                  <S.inputW50>
                    <Field name="area">
                      {({ field, meta }) => (
                        <InputCard
                          id="area"
                          value={contato.area}
                          addonBefore="DDD"
                          placeholder="DDD"
                          mask="99"
                          maskChar=""
                          onChange={handleChangeContato}
                          className={
                            meta.touched && meta.error ? "error-id" : null
                          }
                          requiredInfo
                          {...field}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="area"
                      component="div"
                      className="error-message"
                    />
                  </S.inputW50>
                  <S.inputW50>
                    <Field name="telefone">
                      {({ field, meta, form }) => (
                        <InputCard
                          id="telefone"
                          value={form.values.telefone || ""}
                          addonBefore="Telefone"
                          mask="99999-9999"
                          maskChar=""
                          maxLength={10}
                          placeholder="99999-9999"
                          onChange={(e) => {
                            const formatted = formatPhoneNumber(e.target.value);
                            form.setFieldValue("telefone", formatted);
                          }}
                          className={
                            meta.touched && meta.error ? "error-id" : ""
                          }
                          requiredInfo
                          {...field}
                        />
                      )}
                    </Field>
                    <ErrorMessage
                      name="telefone"
                      component="div"
                      className="error-message"
                    />
                  </S.inputW50>
                </S.ModalRowWrap>
              </S.ModalAddWrapper>
              <S.ModalRow>
                <div
                  className="center"
                  style={{
                    marginTop: "1rem",
                  }}
                >
                  <div className="btns-send center">
                    <DSButton
                      type="button"
                      buttonText="Cancelar"
                      buttonType="primary"
                      isCancelType
                      onClick={() => closeModal()}
                      disabled={loading}
                      style={{
                        color: designSystemColors.generalButtons,
                        fontWeight: "bold",
                        border: `1px solid ${designSystemColors.generalButtons}`,
                        borderRadius: "4px",
                      }}
                    />
                    <DSButton
                      type="submit"
                      style={{
                        backgroundColor: !isButtonDisabled
                          ? designSystemColors.generalButtons
                          : designSystemColors.disabledButtons,
                        color: designSystemColors.textGeneralButtons,
                        border: "none",
                        borderRadius: "0.25rem",
                        fontWeight: "bold",
                        cursor: isButtonDisabled ? "not-allowed" : "pointer",
                      }}
                      isLoading={loading}
                      disabled={isButtonDisabled}
                      buttonText="Editar dependente"
                    />
                  </div>
                </div>
              </S.ModalRow>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};
